mergeMergeTrees